import {updateSidebarHeight} from "./updateSidebarHeight";
import {setTimer} from "./setTimer";
import {scrollImage} from "./scrollImage";

export const initAsideSidebar = () => {
    const sidebars = Array.from(document.querySelectorAll(`main > aside.sidebar`));

    if ( sidebars.length )
    {
        const components = Array.from(document.querySelector(`main`).children);

        sidebars.forEach( (sidebar) => {
            const sidebarIndex = components.indexOf(sidebar);
            const item = sidebar.querySelector(`a`);
            const timerContainer = item.querySelector(`span.counter`);
            const startTime = item.getAttribute(`data-start-time`);
            const endTime = item.getAttribute(`data-end-time`);
            const startValue = item.getAttribute(`data-start-value`);
            const endValue = item.getAttribute(`data-end-value`);
            const image = item.querySelector(`picture > img`);

            if ( !sidebarIndex )
            {
                return;
            }

			const scrollUpClass = `scroll-up`;
			let lastScroll = window.pageYOffset;
            const updateSidebar = () => {
                updateSidebarHeight( components, sidebarIndex );
                scrollImage(sidebar, item, image);
				
				if ( window.pageYOffset < lastScroll )
				{
					item.classList.add( scrollUpClass );
				}
				else
				{
					item.classList.remove( scrollUpClass );
				}
				
				lastScroll = window.pageYOffset;
            };

            updateSidebar();
            
            window.addEventListener(`resize`, updateSidebar);
            window.addEventListener(`scroll`, updateSidebar);
			
			const header = document.querySelector( `header.header-no-border` );
			if ( header )
			{
				window.addEventListener( `resize`, () => {
					if ( header.classList.contains( `fixed` ) && header.classList.contains( `show` ) )
					{
						item.classList.add( scrollUpClass );
					}
				} );
			}

            if (item.classList.contains(`timer`) && endTime)
            {
                setTimer(sidebar, endTime, timerContainer);
            }

            if (item.classList.contains(`counter`) && startTime && endTime && startValue && endValue)
            {
                const startTimeArray = startTime.replace(/\D/g,` `).split(` `);
                const endTimeArray = endTime.replace(/\D/g,` `).split(` `);
                endTimeArray[1]-= 1;
                startTimeArray[1] -= 1;
                const current = new Date() - new Date(...startTimeArray);
                const total = new Date(...endTimeArray) - new Date(...startTimeArray);
                const percentages = current * 100 / total;
                const diffValue = parseFloat(startValue) - parseFloat(endValue);
                const currentValue = parseFloat(startValue) - Math.floor(percentages * diffValue / 100);

                if ( currentValue <= parseFloat(endValue))
                {
                    sidebar.style.display = `none`;
                } else 
                {
                    timerContainer.textContent = currentValue;
                }
            }
        });
    }
};
